import React from 'react';
import { SectionShell } from '../SectionShell';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCTA() {
  return <SectionShell tone="darker" data-id="element-155" data-mp="3msqq2adyq2nb">
      <div className="text-center" data-id="element-156" data-mp="3mrnye08tfw6c">
        <h2 className="font-display text-2xl uppercase leading-tight text-white sm:text-4xl" data-id="element-157" data-mp="3rslbvzivs21i">
          Ready to stop searching and start with the right card?
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-sky-100/75" data-id="element-158" data-mp="3dvgcgidoa1f8">
          Organize a TRT consultation in 5 minutes or less with a visual decision system built
          around the clinical questions you actually face.
        </p>

        <div className="mt-7" data-id="element-159" data-mp="38v20wqcv49cg">
          <CTAButton label="Get the TRT Decision Deck™" subline="Only $27 · Instant digital access · Lifetime access · 7-day guarantee" data-id="element-160" data-mp="38u91kag8gm4c" />
        </div>

        <div className="mt-8" data-id="element-161" data-mp="17245qnvm54oc">
          <Countdown data-id="element-162" data-mp="1709rfseukat8" />
        </div>

        <div className="mt-5" data-id="element-163" data-mp="q7txlda7m2cm">
          <ScarcityBar data-id="element-164" data-mp="q72akquohcxy" />
        </div>

        <p className="mt-4 text-xs text-sky-100/50" data-id="element-165" data-mp="l9k5xcnp1jvr">
          Currency is automatically converted according to your country.
        </p>
      </div>
    </SectionShell>;
}